import { useLocation } from "react-router-dom";
import { setNotification } from "../../utils/Notifications";
import { ChallengeNotificationPage } from "../../components/StaticNotification";
import PageTitle, { LoadingTitle } from "../../components/PageTitle";
import ScrollContent from "../../components/ScrollContent";
import "./styles.css";
import TopMenu from "../../components/TopMenu";
import BottomMenu from "../../components/BottomMenu";
import { useEffect, useState } from "react";
import useCustomNavigate from "../../utils/CustomNavigate";
import ColleaguesList from "../../components/ColleaguesList";
import { hasCongratulatedToday } from "../../utils/API/interaction";

const ChallengeCompletedByPage = () => {
  const location = useLocation();
  const navigator = useCustomNavigate();
  const [congratulationStatus, setCongratulationStatus] = useState({});

  useEffect(() => {
    if (!location || !location.state || !location.state.colleagues_list) {
      setNotification("Error loading page...");
      navigator("/challenge");
      return;
    }

    // Check congratulation status for each colleague
    const checkCongratulationStatus = async () => {
      const status = {};
      for (const colleague of location.state.colleagues_list) {
        const result = await hasCongratulatedToday(colleague.id);
        if (result.code === 200) {
          status[colleague.id] = result.hasCongratulated;
        }
      }
      setCongratulationStatus(status);
    };

    checkCongratulationStatus();
  }, [location]);

  let backState = {};
  if (location.state?.back) backState = { back: location.state.back };

  if (!location || !location.state || !location.state.colleagues_list) {
    return (
      <>
        <TopMenu
          backLink="challenge"
          backLinkState={backState}
          showMenu={false}
        />
        <LoadingTitle />
        <BottomMenu active="challenge" />
      </>
    );
  }

  const handleCongratsSent = (colleagueId) => {
    setCongratulationStatus(prev => ({
      ...prev,
      [colleagueId]: true
    }));
  };

  return (
    <>
      <TopMenu
        backLink="challenge"
        backLinkState={backState}
        showMenu={false}
      />
      <PageTitle 
        float="left"
        title_style={{ color: '#E8205C' }}
      >
        Completed by {location.state.colleagues_list.length} colleague
        {location.state.colleagues_list.length > 1 && "s"}!
      </PageTitle>

      <ScrollContent className="absolute completed-by-scroll-content">
        <ColleaguesList 
          colleagues={location.state.colleagues_list}
          congratulationStatus={congratulationStatus}
          onCongratsSent={handleCongratsSent}
        />
      </ScrollContent>

      <BottomMenu active="challenge" />
    </>
  );
};

export default ChallengeCompletedByPage;
